export const NONE = 'None';
export const IN_APP_URL = 'InAppUrl';
export const OUT_OF_APP_URL = 'OutOfAppUrl';
export const PHONE = 'PhoneNumber';
export const APP_VIEW = 'AppView';
export const PHOTO = 'Photo';
